import { Component, Inject, Input, OnInit } from '@angular/core'
import { GameScoresComponent } from '../game-scores/game-scores.component'
import {
  GamePlayPlayer,
  gamePlayPlayerNull,
  GamePlayService,
  PlayerGameResult,
  playerGameResultNull,
  playerScoreCardNull,
} from 'game-play-services'
import { MatButton } from '@angular/material/button'
import { WindowService } from 'shared-services'
import { gameSetupSiteBaseUrlToken } from '../../providers/game-setup-site-base-url.provider'

@Component({
  selector: 'sans-game-play-results',
  standalone: true,
  templateUrl: './game-play-results.component.html',
  styleUrl: './game-play-results.component.scss',
  imports: [GameScoresComponent, MatButton],
})
export class GamePlayResultsComponent implements OnInit {
  @Input() public gamePlayId = ''
  @Input() public user: GamePlayPlayer = gamePlayPlayerNull
  @Input() public rightOpponent: GamePlayPlayer = gamePlayPlayerNull
  @Input() public leftOpponent: GamePlayPlayer = gamePlayPlayerNull

  @Input() public userPlayerScoreCard = playerScoreCardNull
  @Input() public leftOpponentPlayerScoreCard = playerScoreCardNull
  @Input() public rightOpponentPlayerScoreCard = playerScoreCardNull

  public title = $localize`:GamePlayResultsComponent|Title:Game Results`
  public homeButtonLabel = $localize`:GamePlayResultsComponent|homeButtonLabel:Home`

  public centerPlayerGameResult: PlayerGameResult = playerGameResultNull
  public rightPlayerGameResult: PlayerGameResult = playerGameResultNull
  public leftPlayerGameResult: PlayerGameResult = playerGameResultNull

  public constructor(
    private readonly gamePlayService: GamePlayService,
    private readonly windowService: WindowService,
    @Inject(gameSetupSiteBaseUrlToken) private gameSetupSiteBaseUrl: string,
  ) {}

  public async ngOnInit() {
    const playerGameResults = await this.gamePlayService.getPlayerGameResults(
      this.gamePlayId,
    )

    this.centerPlayerGameResult =
      playerGameResults.find((player) => player.sitPosition === 'Center') ??
      playerGameResultNull

    this.rightPlayerGameResult =
      playerGameResults.find((player) => player.sitPosition === 'Right') ??
      playerGameResultNull

    this.leftPlayerGameResult =
      playerGameResults.find((player) => player.sitPosition === 'Left') ??
      playerGameResultNull
  }

  public onHomeClicked(): void {
    this.windowService.replace(this.gameSetupSiteBaseUrl)
  }
}
